<template>
    <div class="h-full w-full flex flex-col">
        <EventForm mode="edit" :selected-item="selectedItem" :entities="entities" @close="$emit('close')" @updated="$emit('updated')" />
    </div>
</template>

<script>
import EventForm from "./form.vue";
export default {
    name: "event-edit",
    emits: ["updated"],
    components: { EventForm, },
    props: ["selectedItem", "entities"],
}
</script>